import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, View } from "react-native";

import PatientAvatar from "./PatientAvatar";
import PatientDetail from "./PatientDetail";

export default class PatientAvatarWithDetail extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["f", "m"]).isRequired
  };

  render() {
    const { cardNumber, fullName, gender } = this.props;

    return (
      <View style={styles.container}>
        <PatientAvatar cardNumber={cardNumber} gender={gender} />
        <View style={styles.detailContainer}>
          <PatientDetail cardNumber={cardNumber} fullName={fullName} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    flexGrow: 1
  },
  detailContainer: {
    marginStart: 15
  }
});
